export default [
  {
    name: 'dps_settlement',
    path: '/dps_settlement',
    component: () =>
      import(/* webpackChunkName: "dps_settlement" */ './DPSSettlement.vue')
  },
  {
    name: 'dps_refund_failed',
    path: '/dps_refund_failed',
    component: () =>
      import(
        /* webpackChunkName: "dps_refund_failed" */ './DPSRefundFailed.vue'
      )
  }
]
